import { render, staticRenderFns } from "./mangoTree.vue?vue&type=template&id=53ebddd0&scoped=true&"
import script from "./mangoTree.vue?vue&type=script&lang=js&"
export * from "./mangoTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebddd0",
  null
  
)

export default component.exports